/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import './Tag.scss'
import React from 'react'

function Tag(props) {
  const id = props.id ? 'tag-' + props.id : ''

  return <span className={`tag ${id}`}>{props.children}</span>
}

export default Tag
